export enum CompanyStatus {
  None = 0,
  Active,
  Inactive,
}
